import { action, computed, makeObservable, observable } from 'mobx';

import { AUTH_MODES } from '@/configs/authMode';
import { ENDPOINTS } from '@/configs/endpoints';
import { KRATOS_UI_URL, USE_KRATOS_API } from '@/configs/env';
import type { SessionStore } from '@/stores/global/RootStore/SessionStore';
import { ILocalStore } from '@/stores/interfaces/ILocalStore';
import { MetaStore } from '@/stores/local/shared/MetaStore';
import call from '@/utils/api';

export class UnauthorizedPageStore implements ILocalStore {
  readonly loadLoginUrlMeta = new MetaStore();
  loginUrl: string | null = null;

  constructor(private readonly sessionStore: SessionStore) {
    makeObservable(this, {
      loginUrl: observable.ref,
      isPhoneTotpOnlyMode: computed,
      loadLoginUrl: action.bound,
    });
  }

  /** В режиме `phone_totp_only` единственный вход — по телефону, внешний redirect_url не нужен. */
  get isPhoneTotpOnlyMode() {
    return this.sessionStore.authMode === AUTH_MODES.PHONE_TOTP_ONLY;
  }

  async loadLoginUrl(): Promise<void> {
    this.loadLoginUrlMeta.setLoadedStartMeta();

    const response = await call<{ redirect_url: string }>({
      endpoint: ENDPOINTS.sessions.whoami,
    });

    if (!response.isError && 'redirect_url' in response.data) {
      this.loginUrl = response.data.redirect_url;
    } else if (USE_KRATOS_API) {
      this.loginUrl = `${KRATOS_UI_URL}/login?return_url=${window.location.href}`;
    }
    this.loadLoginUrlMeta.setLoadedSuccessMeta();
  }

  destroy(): void {
    this.loadLoginUrlMeta.destroy();
  }
}
